import React from 'react';
import { View, TouchableOpacity, StyleSheet, ViewStyle } from 'react-native';
import { usePathname, useRouter } from 'expo-router';
import * as Haptics from 'expo-haptics';
import { LinearGradient } from 'expo-linear-gradient';
import StarsIcon from './icons/StarsIcon';
import LoadingIcon from './icons/LoadingIcon';
import FlagIcon from './icons/FlagIcon';
import MegaphoneIcon from './icons/MegaphoneIcon';
import RecordIcon from './icons/RecordIcon';
import { RecordVideoGlyph } from '@/components/video/lobby/LobbyControlPill';

interface BillBottomNavProps {
  style?: ViewStyle;
}

export default function BillBottomNav({ style }: BillBottomNavProps) {
  const pathname = usePathname();
  const router = useRouter();

  const isActive = (path: string) => {
    if (path === '/' || path === '/(tabs)') {
      return (
        pathname === '/' ||
        pathname === '/(tabs)' ||
        pathname === '/(tabs)/' ||
        pathname === '/(tabs)/index'
      );
    }
    if (path === '/trail') {
      return pathname === '/trail' || pathname.startsWith('/trail/');
    }
    return pathname === path || pathname.startsWith(path + '/');
  };

  const handlePress = (path: string) => {
    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
    router.replace(path as any);
  };

  const isBillActive = isActive('/');

  return (
    <View style={[styles.navbar, style]}>
      <View style={styles.navbarContent}>
        {/* 1. Diary */}
        <TouchableOpacity
          style={[styles.navbarLink, isActive('/diary') && styles.navbarLinkActive]}
          activeOpacity={0.7}
          onPress={() => handlePress('/diary')}
        >
          <View style={styles.iconContainer}>
            <LoadingIcon size={24} color={isActive('/diary') ? '#151515' : '#A19F97'} />
          </View>
        </TouchableOpacity>

        {/* 2. Trail */}
        <TouchableOpacity
          style={[styles.navbarLink, isActive('/trail') && styles.navbarLinkActive]}
          activeOpacity={0.7}
          onPress={() => handlePress('/trail')}
        >
          <View style={styles.iconContainer}>
            <FlagIcon
              isActive={isActive('/trail')}
              color={isActive('/trail') ? '#151515' : '#A19F97'}
            />
          </View>
        </TouchableOpacity>

        {/* 3. Encontros */}
        <TouchableOpacity
          style={[styles.navbarLink, isActive('/encontros-online') && styles.navbarLinkActive]}
          activeOpacity={0.7}
          onPress={() => handlePress('/encontros-online')}
        >
          <View style={styles.iconContainer}>
            <MegaphoneIcon
              isActive={isActive('/encontros-online')}
              color={isActive('/encontros-online') ? '#151515' : '#A19F97'}
            />
          </View>
        </TouchableOpacity>

        {/* 4. Agendamentos */}
        <TouchableOpacity
          style={[styles.navbarLink, isActive('/agendamentos') && styles.navbarLinkActive]}
          activeOpacity={0.7}
          onPress={() => handlePress('/agendamentos')}
        >
          <View style={styles.iconContainer}>
            {isActive('/agendamentos') ? (
              <RecordIcon size={24} />
            ) : (
              <RecordVideoGlyph color='#A19F97' size={24} />
            )}
          </View>
        </TouchableOpacity>

        {/* 5. Bill — moved to last position, plus blue inactive, gradient active */}
        <TouchableOpacity
          style={[styles.navbarLink, isBillActive && styles.billActiveLink]}
          activeOpacity={0.7}
          onPress={() => handlePress('/(tabs)')}
        >
          {isBillActive ? (
            <LinearGradient
              colors={['#669AB7', '#8AB3CC']}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 1 }}
              style={styles.billActiveGradient}
            >
              <View style={styles.iconContainer}>
                <StarsIcon activeOnBlue={true} size={24} />
              </View>
            </LinearGradient>
          ) : (
            <View style={styles.iconContainer}>
              <StarsIcon filled={true} color='#669AB7' size={24} />
            </View>
          )}
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  navbar: {
    backgroundColor: '#F9F8F3',
    borderTopWidth: 1,
    borderTopColor: '#F0EEE4',
    zIndex: 100,
    paddingTop: 6,
    paddingBottom: 6,
    paddingHorizontal: 24,
  },
  navbarContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  navbarLink: {
    borderRadius: 70,
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 44,
    padding: 10,
    marginHorizontal: 4,
  },
  navbarLinkActive: {
    backgroundColor: '#DAD8CF',
  },
  billActiveLink: {
    backgroundColor: 'transparent',
    overflow: 'hidden',
  },
  billActiveGradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: 70,
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconContainer: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
